import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarChart from '../common/Charts/BarChart';
// import ResizeAware from 'react-resize-aware';
import {
  processData,
  MAAP_ICONS,
  processIcons,
  checkAsterickFormate,
} from '../../util/QuickReportsUtils';
import * as messages from "../../messages/ReportsMessages";
import { MODULE_MEDIA_ACTIVITY_PLATFORM } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

export default class MediaActivityPlatform extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRadioButton: 'Index',
      selectedDropdown: 'Camera',
      nextDropdown: 'Camera',
      selectedDropdownValue: 'camera',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      rename: {},
      renameValuekey: {},
      hideIcon: {},
      remove: {},
      removeIndex: [],
      combos: [],
      // barChartWidth: null,
    };
  }

  componentDidMount() {
    this.props.handletitle('Media Activity Across Platform: Last 7 Days');
    this.props.handleFooter(
      'Camera, Email, Listen to Music, Talk, Messaging and Video excludes activity behaviors from iOS8 devices and greater.',
    );
    // (option, subtype, combos)
    this.props.handleExportParams(
      this.state.selectedRadioButton,
      this.state.selectedDropdownValue,
      this.state.combos,
      this.state.removeIndex,
    );
    this.props.trackerFn({ subModule: MODULE_MEDIA_ACTIVITY_PLATFORM });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        selectedDropdown: this.state.nextDropdown,
        removeIndex: [],
      });
    }
}

  handleDropdownChange = e => {
    this.props.runReport(e.currentTarget.value);
    const value = this.props.dropdown.filter(
      item => item.key === e.target.value,
    );
    this.setState(
      {
        nextDropdown: value[0].value,
        selectedDropdownValue: e.currentTarget.value,
      },
      () => {
        this.props.handleExportParams(
          this.state.selectedRadioButton,
          this.state.selectedDropdownValue,
          this.state.combos,
          this.state.removeIndex,
        );
      },
    );
  };

  handleRadioButtonChange = e => {
    this.setState({ selectedRadioButton: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        this.state.selectedDropdownValue,
        this.state.combos,
        this.state.removeIndex,
      );
      this.props.handletitle('Media Activity Across Platform: Last 7 Days');
    });
  };

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  processLabels = () =>
    this.props.data[this.state.selectedDropdown]
      .map(({ label, value }) => {
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
          };
        }
        return { label, value };
      })
      .filter(({ label }) => !this.state.remove[label])
      .map(({ label }) => label);

  removeBar = key => {
    const index = this.props.data[this.state.selectedDropdown].findIndex(
      x => x.label === key,
    );
    this.setState(
      {
        remove: { ...this.state.remove, [key]: true },
        removeIndex: [...this.state.removeIndex, index],
      },
      () =>
        this.props.handleExportParams(
          this.state.selectedRadioButton,
          this.state.selectedDropdownValue,
          this.state.combos,
          this.state.removeIndex,
        ),
    );
  };

  combineWith = (sourceKey, sourceLabel, combineWithLabel) => {
    const source = this.props.data[this.state.selectedDropdown]
      .map(({ label, value }) => {
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
          };
        }
        return { label, value };
      })
      .filter(({ label }) => label === sourceLabel);
    const destination = this.props.data[this.state.selectedDropdown]
      .map(({ label, value }) => {
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
          };
        }
        return { label, value };
      })
      .filter(({ label }) => label === combineWithLabel);
    const sourceIndex =
      source[0].value.rowIndex || source[0].value.comboIndexes || 0;
    const destinationIndex =
      destination[0].value.rowIndex || destination[0].value.comboIndexes || 0;
    let combos = [];
    if (Array.isArray(sourceIndex) && Array.isArray(destinationIndex)) {
      combos = this.state.combos.filter(
        combo =>
          !(
            JSON.stringify(sourceIndex) === JSON.stringify(combo) ||
            JSON.stringify(destinationIndex) === JSON.stringify(combo)
          ),
      );
      combos.push([...sourceIndex, ...destinationIndex]);
    } else if (Array.isArray(sourceIndex)) {
      combos = this.state.combos.filter(
        combo => !(JSON.stringify(sourceIndex) === JSON.stringify(combo)),
      );
      combos.push([...sourceIndex, destinationIndex]);
    } else if (Array.isArray(destinationIndex)) {
      combos = this.state.combos.filter(
        combo => !(JSON.stringify(destinationIndex) === JSON.stringify(combo)),
      );
      combos.push([sourceIndex, ...destinationIndex]);
    } else {
      combos = this.state.combos;
      combos.push([sourceIndex, destinationIndex]);
    }
    this.setState({ combos }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        this.state.selectedDropdownValue,
        this.state.combos,
        this.state.removeIndex,
      );
    });
    this.props.runReport(this.state.selectedDropdownValue, combos);
  };

  hideIcon = key => {
    this.setState({
      hideIcon: { ...this.state.hideIcon, [key]: !this.state.hideIcon[key] },
    });
  };

  renameLabel = (key, value) => {
    this.setState({
      rename: { ...this.state.rename, [key]: value },
      renameValuekey: { ...this.state.rename, [value]: key },
    });
  };

  renderDropdown = () =>
    this.props.dropdown.map(({ key, value }) => (
      <option value={key} key={key}>
        {value}
      </option>
    ));

  // handleCrosstabViewerGridContainerResize = (dimensions) => {
  //   this.setState({ barChartWidth: dimensions.width });
  // }
  
  getRowData = () => {
    if (this.props.data[this.state.selectedDropdown]) {
       return this.props.data[this.state.selectedDropdown];
    } 
      return this.props.data[this.props.dropdown[0].value];
  }

  render() {
    const dropdownWindow = this.props.dropdownWindow;
    const that = this;
    const defaultSelectedIcon = 'Camera';
    return (
      <div
        className="quick-report-graph-wrapper"
        style={{ paddingBottom: '70px' }}
      >
        <div className="large-12 text-center margin-top-10 margin-bottom-10">
          <div className="quick-report-dropdown display-inline">
            <select
              onChange={this.handleDropdownChange}
              value={this.props.data[this.state.selectedDropdown] ? this.state.selectedDropdownValue : 'Camera'}
            >
              {this.renderDropdown()}
            </select>
          </div>
          <div className="quick-report-radio display-inline">
            <p>
              <input
                type="radio"
                id="percentType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Percent'}
                onChange={this.handleRadioButtonChange}
                value="Percent"
              />
              <label htmlFor="percentType">
                <span>Percent</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="indexType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Index'}
                onChange={this.handleRadioButtonChange}
                value="Index"
              />
              <label htmlFor="indexType">
                <span>Index</span>
              </label>
            </p>
          </div>
        </div>
        <div className="column large-12">
          {/* <ResizeAware
            style={{ position: 'relative', width: '100%' }}
            onResize={this.handleCrosstabViewerGridContainerResize}
          > */}
          <BarChart
            chartColor={chartColor}
            data={{
              processedData: processData(
                {
                  rawData: this.getRowData(),
                  y:
                    this.state.selectedRadioButton === 'Percent'
                      ? 'pct'
                      : 'index',
                  colorValue:
                    this.state.selectedRadioButton === 'Percent'
                      ? undefined
                      : 100,
                  maxColor: '#247BA0',
                  minColor: '#F25F5C',
                  coloreConfig: this.props.data[this.state.selectedDropdown] ? MAAP_ICONS[this.state.selectedDropdown] :
                  MAAP_ICONS[defaultSelectedIcon],
                },
                this.updateAsteriskStatus,
                this.props.study,
                this.state.remove,
                this.state.rename,
              ),
              tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
            }}
            plotLines={[
              {
                color: '#30435d',
                value: 100,
                width: 2,
              },
            ]}
            dataLabels
            xLabelPadding={30}
            xAxisLabelDistance={0}
            chartType="column"
            yLabel={
              this.state.selectedRadioButton === 'Percent'
                ? '{value}%'
                : '{value}'
            }
            dataLabelFormat={
              this.state.selectedRadioButton === 'Percent'
                ? checkAsterickFormate(
                    '{y}%',
                    this.state.showDoubleAsterisk,
                    this.state.showSingleAsterisk,
                  )
                : checkAsterickFormate(
                    '{y}',
                    this.state.showDoubleAsterisk,
                    this.state.showSingleAsterisk,
                  )
            }
            clickEvent={event => {
              dropdownWindow
                .current
                .setCoordinates(
                  event,
                  event.target.point,
                  that.props.data,
                  that.state.ReportDropdown,
                  that.processLabels(),
                  that.removeBar,
                  that.hideIcon,
                  that.combineWith,
                  null,
                  that.renameLabel,
                  'normal',
                );
            }}
            yAxisText={
              this.state.selectedRadioButton === 'Percent'
                ? 'Percentage'
                : 'Index'
            }
            labelFormatter={processIcons(
              MAAP_ICONS[this.state.selectedDropdown],
              this.state.remove,
              this.state.hideIcon,
              this.state.rename,
            )}
          />
          {/* </ResizeAware> */}
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

MediaActivityPlatform.propTypes = {
  data: PropTypes.shape({}),
  dropdown: PropTypes.arrayOf(PropTypes.shape({})),
  handletitle: PropTypes.func,
  handleFooter: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  dropdownWindow: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
